<template>
  <div
    v-if="visible"
    class="mx-3 mb-2 rounded-lg border border-[var(--p-primary-200)] bg-[var(--p-primary-50)]/80 px-4 py-3 shadow-sm dark:border-[var(--p-primary-700)]/60 dark:bg-[var(--p-primary-900)]/20"
  >
    <div class="mb-2 flex items-center gap-2">
      <IconLanguage
        stroke-width="2"
        width="16"
        height="16"
        class="shrink-0 text-[var(--p-primary-color)]"
      />
      <span class="text-xs font-medium text-[var(--p-primary-color)]">
        {{ $t('whatsapp.translation_preview') }}
      </span>
    </div>

    <div class="min-h-6 px-1 py-1">
      <TypingIndicator v-if="isLoading" />
      <p
        v-else-if="translatedText"
        class="text-xs leading-relaxed text-[var(--p-surface-700)] dark:text-[var(--p-surface-200)]"
      >
        {{ translatedText }}
      </p>
      <p
        v-else
        class="text-xs leading-relaxed text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
      >
        {{ $t('whatsapp.preview_message_here') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import TypingIndicator from '@/components/atoms/typing/TypingIndicator.vue'
import IconLanguage from '@/assets/svg/languaje-icon.svg?component'

interface Props {
  visible: boolean
  isLoading?: boolean
  translatedText?: string
}

defineProps<Props>()
</script>
